function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTickIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(31.764706%,31.764706%,31.764706%)",
      fillOpacity: 1
    },
    d: "M 15.085938 3.066406 L 14.65625 2.636719 C 14.183594 2.164062 13.410156 2.164062 12.941406 2.636719 L 5.648438 9.929688 L 3.058594 7.34375 C 2.589844 6.871094 1.816406 6.871094 1.34375 7.34375 L 0.914062 7.773438 C 0.441406 8.242188 0.441406 9.015625 0.914062 9.488281 L 4.785156 13.363281 C 5.257812 13.835938 6.03125 13.835938 6.503906 13.363281 L 15.085938 4.78125 C 15.554688 4.308594 15.554688 3.539062 15.085938 3.066406 Z M 15.085938 3.066406 "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTickIcon);
export default __webpack_public_path__ + "static/media/tickIcon.5a28aae0b416fcafa878c37366d7e584.svg";
export { ForwardRef as ReactComponent };